export default __webpack_public_path__ + "static/media/investment-privilege.e17c0bbf.png";